import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'
import styles from './sonner.module.scss'
import clsx from 'clsx'

export const SonnerToaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className={clsx('toaster group', styles.toaster)}
      icons={{
        success: <CircleCheckIcon className="size-16" />,
        info: <InfoIcon className="size-16" />,
        warning: <TriangleAlertIcon className="size-16" />,
        error: <OctagonXIcon className="size-16" />,
        loading: <Loader2Icon className="size-16 animate-spin" />,
      }}
      style={
        {
          '--width': '370rem',
        } as React.CSSProperties
      }
      position="top-center"
      {...props}
    />
  )
}
